import type { AssetLite } from "@/entities/asset";
import type { LocationSelectParentValue } from "@/modules/location/location-select-parent";

import { useTranslation } from "react-i18next";

import { useAssetsBatchUpdate } from "@/entities/assets";
import { useBatchEditForm } from "@/modules/batch-edit-form";
import { isSameQueryableSelectOptionItem } from "@/modules/queryable-select";

import {
  getAssetsBatchEditLocationInitialValue,
  shouldDisableAssetsBatchEditLocation,
} from "./assets-batch-edit-location.helper";

export const useDisableAssetsBatchEditLocation = (assets?: AssetLite[]) => {
  const { t } = useTranslation();

  const disabled = shouldDisableAssetsBatchEditLocation(assets);

  const tooltip = t("asset:batchEdit.location.disabledTooltip");

  return {
    disabled,
    tooltip: disabled ? tooltip : undefined,
  };
};

export const useAssetsBatchEditLocation = (assets: AssetLite[]) => {
  const fieldName = "location";
  const propertyName = "location_id";

  const initialValue = getAssetsBatchEditLocationInitialValue(assets);

  const { mutate, isPending, status, error } = useAssetsBatchUpdate(assets);

  const onMutateReady = (option: LocationSelectParentValue) => {
    if (!option) return;
    mutate({ [propertyName]: option.value });
  };

  const formProps = useBatchEditForm<LocationSelectParentValue>({
    fieldName,
    initialValue,
    isEqualFn: ({ initialValue, formValue }) =>
      isSameQueryableSelectOptionItem(initialValue, formValue),
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
